// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class NewWorkerQueryDto extends APIModel {
    firstRegistrationQuestionAnswer: string;
    secondRegistrationQuestionAnswer: string;
    companyId: number;

    constructor(options?: APIModelOptions) {
        super(NewWorkerQueryDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "firstRegistrationQuestionAnswer", type: "string" },
            { name: "secondRegistrationQuestionAnswer", type: "string" },
            { name: "companyId", type: "number" }
        ];
    }
}




